// theme.js
import { tosh } from '@theme-ui/presets'

export  const theme = {
  ...tosh,
  styles: {
    ...tosh.styles,
  },
}
